/** Line-row chip for the default visit window; duration-only lines keep the minutes form. */
import { ServiceLineDefaultWindow } from '@jms/model';

export interface OutlineWindowChip {
  label: string;
  tooltip: string;
}

export function outlineLineWindowChip(window: ServiceLineDefaultWindow | undefined, duration: number | undefined): OutlineWindowChip | null {

  if (window?.start && window.end) {
    const label = `${window.start} – ${window.end}${window.overnight ? ' +1' : ''}`;
    return { label, tooltip: duration != null ? `Visit window: ${label} (${duration} min)` : `Visit window: ${label}` };
  }
  if (duration != null) return { label: `${duration} min`, tooltip: `Duration: ${duration} minutes` };
  return null;
}
